export const url = "https://pos.api.invetix.in/api/store";
export const API_URL = "https://invetix-api.invetix.in"
export const API_KEY = "APIKEYINVETIXCONTACTSALESSUPPORT"
export const RAZORPAY_KEY = "rzp_live_hhSCvKkeMBD0ky"
// export const RAZORPAY_KEY = "rzp_test_K2fZ0vLlM0Mfjp"